export default "__VITE_ASSET__DtGvPz$v__"